const PostsActionType = {
	CREATE_POST: 'CREATE_POST',
	FETCH_POSTS: 'FETCH_POSTS',
	REQUEST_POSTS: 'REQUEST_POSTS',
	
	SHOW_LOADER: 'SHOW_LOADER',
	HIDE_LOADER: 'HIDE_LOADER',
	
	SHOW_ALERT: 'SHOW_ALERT',
	HIDE_ALERT: 'HIDE_ALERT',
};

export default PostsActionType;